import React, { useEffect, useId, useState } from "react";
import { useLocation } from "react-router-dom";
import { BaseUrl } from "../../helper/BaseUrl";
export default function DynamicFaqSection({ data }) {
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [faqData, setFaqData] = useState(null);
  useEffect(() => {
    const fetchFaq = async () => {
      try {
        const pageUrl = `https://catalyze.co.in${location.pathname}`;
        const response = await fetch(`${BaseUrl}/api/faq-by-url`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            url: pageUrl,
          }),
        });
        const result = await response.json();
        setFaqData(result?.faq || null);
      } catch (error) {
        console.error("FAQ fetch error:", error.message);
      }
    };
    fetchFaq();
  }, [location.pathname]);
  const faqItems = faqData?.faqs?.length ? faqData.faqs : data?.items || [];
  if (!faqItems.length) return null;
  return (
    <>
      <section className="dynamic-faq-section">
        <div className="container">
          <div className="dynamic-faq-heading text-center">
            <span className="main-title"> HAVE QUESTIONS?</span>
            <h2 className="heading"> Let’s Make It Clear </h2>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="dynamic-faq-list">
                {faqItems.map((item, index) => {
                  const isOpen = activeIndex === index;
                  return (
                    <div className="dynamic-faq-item"  key={item?.question || index} >
                      <h3 className="dynamic-faq-question">
                        <button type="button" className="dynamic-faq-trigger"  aria-expanded={isOpen}
                          onClick={() => setActiveIndex(isOpen ? null : index)} >
                          <span>{item?.question}</span>
                          <span  className="dynamic-faq-icon"   aria-hidden="true" />
                        </button>
                      </h3>
                      <div role="region" hidden={!isOpen}>
                        {item?.answer?.includes("<") ? (
                          <div   className="dynamic-faq-answer"   dangerouslySetInnerHTML={{ __html: item.answer }}
                          /> ) : (
                          <p className="dynamic-faq-answer"> {item?.answer} </p>
                        )}
                      </div>
                    </div>  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
